import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";
import $6Fm0V$react from "react";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $c1d7fb2ec91bae71$var$Item(props) {
  return null;
}

$c1d7fb2ec91bae71$var$Item.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props, context) {
  var childItems, title, children, rendered, textValue;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        childItems = props.childItems, title = props.title, children = props.children;
        rendered = props.title || props.children;
        textValue = props.textValue || (typeof rendered === 'string' ? rendered : '') || props['aria-label'] || ''; // suppressTextValueWarning is used in components like Tabs, which don't have type to select support.

        if (!textValue && !(context === null || context === void 0 ? void 0 : context.suppressTextValueWarning) && process.env.NODE_ENV !== 'production') console.warn('<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop.');
        _context2.next = 6;
        return {
          type: 'item',
          props: props,
          rendered: rendered,
          textValue: textValue,
          'aria-label': props['aria-label'],
          hasChildNodes: $c1d7fb2ec91bae71$var$hasChildItems(props),
          childNodes: /*#__PURE__*/_regeneratorRuntime.mark(function childNodes() {
            var _iterator, _step, child, items;

            return _regeneratorRuntime.wrap(function childNodes$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  if (!childItems) {
                    _context.next = 20;
                    break;
                  }

                  _iterator = _createForOfIteratorHelper(childItems);
                  _context.prev = 2;

                  _iterator.s();

                case 4:
                  if ((_step = _iterator.n()).done) {
                    _context.next = 10;
                    break;
                  }

                  child = _step.value;
                  _context.next = 8;
                  return {
                    type: 'item',
                    value: child
                  };

                case 8:
                  _context.next = 4;
                  break;

                case 10:
                  _context.next = 15;
                  break;

                case 12:
                  _context.prev = 12;
                  _context.t0 = _context["catch"](2);

                  _iterator.e(_context.t0);

                case 15:
                  _context.prev = 15;

                  _iterator.f();

                  return _context.finish(15);

                case 18:
                  _context.next = 24;
                  break;

                case 20:
                  if (!title) {
                    _context.next = 24;
                    break;
                  }

                  items = [];
                  (0, $6Fm0V$react).Children.forEach(children, function (child) {
                    items.push({
                      type: 'item',
                      element: child
                    });
                  });
                  return _context.delegateYield(items, "t1", 24);

                case 24:
                case "end":
                  return _context.stop();
              }
            }, childNodes, null, [[2, 12, 15, 18]]);
          })
        };

      case 6:
      case "end":
        return _context2.stop();
    }
  }, getCollectionNode);
});

function $c1d7fb2ec91bae71$var$hasChildItems(props) {
  if (props.hasChildItems != null) return props.hasChildItems;
  if (props.childItems) return true;
  if (props.title && (0, $6Fm0V$react).Children.count(props.children) > 0) return true;
  return false;
} // We don't want getCollectionNode to show up in the type definition


var $c1d7fb2ec91bae71$export$6d08773d2e66f8f2 = $c1d7fb2ec91bae71$var$Item;
export { $c1d7fb2ec91bae71$export$6d08773d2e66f8f2 as Item };